import {catchError, Observable, switchMap, take, throwError, withLatestFrom} from 'rxjs';
import {HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest} from '@angular/common/http';
import {Store} from '@ngrx/store';
import {inject} from '@angular/core';
import {logout} from '../../modules/authentication/store/authentication.actions';
import {sessionId, userId} from '../../modules/authentication/store/authentication.selectors';

const cloneWithAuthHeader = (req: HttpRequest<unknown>, token?: string | null) =>
  token ? req.clone({setHeaders: {'X-Openerp-Session-Id': `${token}`}}) : req;

const handleUnauthorizedError = (error: any, store: Store, userId: number | null) => {
  if (error.status === 401 && userId) {
    store.dispatch(logout());
  }
  return throwError(() => error);
};

export const authenticationInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  if (req.url.includes('/api/public/app/location/create') && req.method === 'GET') {
    return next(req);
  }

  const store = inject(Store);

  return store.select(sessionId).pipe(
    withLatestFrom(store.select(userId)),
    take(1),
    switchMap(([token, id]) => {
      const clonedReq = cloneWithAuthHeader(req, token);
      return next(clonedReq).pipe(
        catchError((error) => handleUnauthorizedError(error, store, id))
      );
    })
  );
};

